// Lib
import { RefObject, useEffect, useMemo, useState } from 'react';
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

// Types
import { RootState } from '@app-types/index';

const useBodyFreeze = (ref: RefObject<HTMLElement | null>): void => {
  const [scroll, setScroll] = useState<number>(0);
  const { title } = useSelector((state: RootState) => state.Popup);
  const { pathname, search } = useLocation();
  const [isBodyDisabled, setIsBodyDisabled] = useState<boolean>(false);

  const pathWithDatepicker = '/settings/personal';
  // const pathWithDragAndDrop = '/link-preview/edit';
  const spotifySelectorPath =
    '/social/spotify?authSuccess=true&withModifier=true';
  const facebookSelectorPath =
    '/social/facebook?authSuccess=true&withModifier=true';
  const pathsWithoutFreeze = useMemo<string[]>(
    () => [
      pathWithDatepicker,
      // pathWithDragAndDrop,
      spotifySelectorPath,
      facebookSelectorPath,
    ],
    [],
  );

  const currentPath = useMemo<string>(
    () => `${pathname}${search}`,
    [pathname, search],
  );

  useEffect(() => {
    if (pathsWithoutFreeze.includes(currentPath) && !isBodyDisabled) {
      clearAllBodyScrollLocks();
      if (typeof window === 'object') {
        window.document.body.style.overflow = 'hidden';
        setIsBodyDisabled(true);
      }
    }
    if (!pathsWithoutFreeze.includes(currentPath) && isBodyDisabled) {
      if (typeof window === 'object') {
        window.document.body.style.overflow = '';
        setIsBodyDisabled(false);
      }
      if (ref && ref.current) disableBodyScroll(ref.current);
    }
  }, [pathsWithoutFreeze, isBodyDisabled, ref, currentPath]);

  useEffect(() => {
    if (ref && ref.current && !pathsWithoutFreeze.includes(currentPath))
      disableBodyScroll(ref.current);

    if (title !== 'Stats') {
      return () => {
        if (isBodyDisabled) {
          window.document.body.style.overflow = 'auto';
        }
        clearAllBodyScrollLocks();
      };
    }
  }, [
    pathsWithoutFreeze,
    scroll,
    setScroll,
    ref,
    title,
    currentPath,
    isBodyDisabled,
  ]);
};

export default useBodyFreeze;
